import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { LocationPicker } from "../LocationPicker";

export const FirstNameSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="firstName">First Name</Label>
      <Input
        id="firstName"
        name="firstName"
        value={value}
        onChange={onChange}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

export const LastNameSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="lastName">Last Name</Label>
      <Input
        id="lastName"
        name="lastName"
        value={value}
        onChange={onChange}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

/**
 * Location section — uses the new LocationPicker component.
 *
 * value:    the picker's currently-displayed location, shape { coordinates, label }
 *           OR null when no location is set
 * onChange: receives either null (cleared) or
 *           { coordinates, label, addressParts, precision } (picked from picker)
 */
export const ProfileLocationSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label>Location</Label>
      <LocationPicker
        value={value}
        onChange={onChange}
        countryCode="ZA"
        error={error}
      />
      <p className="text-xs text-muted-foreground mt-1">
        Your location is used to show you listings nearby. Only your suburb is
        visible to other users — never your exact coordinates.
      </p>
    </div>
  );
};

export const BioSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="bio">Bio</Label>
      <Textarea
        id="bio"
        name="bio"
        rows={4}
        value={value}
        onChange={onChange}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};